export default f => e => {
  e.preventDefault()
  e.stopPropagation()
  f()
}



/** WEBPACK FOOTER **
 ** ./app/utils/eventHandler.js
 **/